import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cta: 'Access my account',
    description: 'You can now access your account.',
    title: 'All good {firstName}!',
  },
  fr: {
    cta: 'Accéder à mon compte',
    description: 'Vous pouvez dès à présent accéder à votre compte.',
    title: 'C’est tout bon {firstName} !',
  },
});

export default locales;
